import React, { Component } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Address from "../containers/Address";
import locales from "../../../_constants/locales";

class AddressSection extends Component {
    render() {
        return (
            <div className="section">
                <div className="section-header">
                    <div className="layout horizontal center title-row">
                        <h2 className="title">{locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.TITLE}</h2>
                    </div>
                </div>
                <div className="section-body">
                    <div className="flex layout vertical">
                        <div>
                            <Address address={this.props.address} handleChange={this.props.handleChange.bind(this)} />
                            {this.props.isAddressSameCheckboxAvailable && (
                                <div className="flex layout horizontal">
                                    <FormControlLabel
                                        className="custom-form-control-label"
                                        control={
                                            <Checkbox
                                                checked={this.props.isAddressSameCheckboxChecked}
                                                onChange={this.props.handleChange.bind(this)}
                                                name="isAddressSameChecked"
                                                color="primary"
                                            />
                                        }
                                        label={locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.RETURN_ADDRESS_SAME.LABEL}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddressSection;
